import { useState } from 'react'

import { fvDate } from '@fv/dates'

import { InputAdornment, InputGroup } from '@/components/inputs/InputGroup'

import { DayPickerPanel } from '../dates/DayPickerPanel'

type DatePickerProps = {
  onClose: () => void
  value?: string
  canClear?: boolean
  onSelect: (d: string) => void
  isOpen: boolean
}

const dateFormat = 'ddd MMM D, YYYY'

type InputProps = {
  className: string
  isBusy: boolean
  canClear?: boolean
  invoiceDate: string
  setInvoiceDate: (d: string) => void
}

export const DatePickerInput = ({
  className,
  isBusy,
  canClear = true,
  invoiceDate,
  setInvoiceDate,
}: InputProps) => {
  const [showDatepicker, setShowDatepicker] = useState(false)

  return (
    <>
      <InputGroup
        className={className}
        inputProps={{
          name: 'invoiceDate',
          onChange: undefined,
          placeholder: 'Invoice date',
          onFocus: () => setShowDatepicker(true),
          readOnly: true,
          disabled: isBusy,
          value: invoiceDate ? fvDate(invoiceDate).format(dateFormat) : '',
        }}
        inputType="text"
        startContent={<InputAdornment position="start" icon="calendar-day" />}
      />
      <DatePickerPanel
        canClear={canClear}
        isOpen={showDatepicker}
        value={invoiceDate}
        onClose={() => setShowDatepicker(false)}
        onSelect={date => {
          setInvoiceDate(date ? fvDate(date).toISOString() : '')
          setShowDatepicker(false)
        }}
      />
    </>
  )
}

const DatePickerPanel = ({
  onClose,
  value,
  onSelect,
  canClear,
  isOpen,
}: DatePickerProps) => {
  const hasClear = !!value && canClear
  const date = value ? fvDate(value).toDate() : undefined

  return (
    <DayPickerPanel
      selected={date}
      showClear={hasClear}
      open={isOpen}
      onClose={onClose}
      mode="single"
      onSelect={d => {
        onSelect(d?.toISOString() ?? '')
      }}
    />
  )
}
